import { css, Theme } from '@emotion/react'
import { alpha } from '@mui/material'
import { chipClasses } from '@mui/material/Chip'
import { scaleBorderRadius } from 'theme/utils'

export const filtersSection = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`

export const filtersSectionOnlySearch = css`
  justify-content: flex-end;
`

export const statusTabs = css`
  flex: 0 0 auto;
`

export const search = css`
  flex: 0 1 320px;
`

export const table = css`
  margin-top: 8px;
`

export const titleText = css`
  font-weight: 600;
`

export const sectionsList = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
`

export const sectionChip = (theme: Theme) => css`
  max-width: 220px;
  height: 28px;
  border: 1px solid ${alpha(theme.colors.blue, 0.22)};
  border-radius: 8px;
  color: ${theme.colors.blue};
  background: ${alpha(theme.colors.blue, 0.08)};
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: ${alpha(theme.colors.blue, 0.14)};
  }

  .${chipClasses.label} {
    max-width: 100%;
    padding: ${theme.spacing(0, 1)};
    overflow: hidden;
    text-overflow: ellipsis;
    color: inherit;
    font-size: 13px;
    line-height: 18px;
  }
`

export const actions = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`

export const actionTooltipTarget = css`
  display: inline-flex;
  flex: 0 0 auto;
`

export const actionButton = (theme: Theme) => css`
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2.5)};
`

export const deleteButton = (theme: Theme) => css`
  color: ${theme.colors.red};

  &.Mui-disabled {
    color: ${theme.typographyColors.typographyFour};

    svg path {
      stroke: ${theme.colors.typographyFour};
    }
  }
`
